/**
 * Careers Disclaimer.
 * @format
 */

import React from 'react';
import { UseFormRegister, FieldValues, FieldErrors } from 'react-hook-form';
import Checkbox from '../../form-components/fields/checkbox';

type CareersDisclaimerProps = {
  register: UseFormRegister<FieldValues>;
  errors?: { [key: string]: FieldErrors };
};

const CareersDisclaimer: React.FC<CareersDisclaimerProps> = ({
  register,
  errors,
}) => {
  return (
    <div className="form-disclaimer">
      <Checkbox
        fieldProperties={{
          fieldTitle: '',
          fieldName: 'career-disclaimer',
          errorMessage: '',
          required: true,
          list: [
            {
              name: 'carreer-disclaimer',
              value: 'career-disclaimer',
              label: `<p>I hereby consent to the processing of my above given personal data by the Siemens Healthineers
                company referred to under Corporate information and for the purpose described above. Further information
                concerning the processing of your data can be found in the Data Privacy Policy. I am aware that I can
                partially or completely revoke this consent at any time in the future. Please declare your revocation to
                the contact address given in the Corporate Information and send it to us via: <a
                  href='mailto:dataprivacy.func@siemens-healthineers.com'>dataprivacy.func@siemens-healthineers.com</a>.
              </p>`,
            },
          ],
          htmlLabel: true,
        }}
        register={register}
        errors={errors}
      />
      <p className={'small-vertical-margin-top font-semibold'}>
        Note: We care about you date privacy and take compliance with GDPR as
        well as other data protection legislation seriously. For the reason, we
        ask you not to send us your CV or resume by e-mail.
      </p>
    </div>
  );
};
export default CareersDisclaimer;
